// extracted by mini-css-extract-plugin
module.exports = {"categoryPage":"Category_categoryPage__M5ycW","categoryHead":"Category_categoryHead__ZgfYW"};